import { render, staticRenderFns } from "./DbModal.vue?vue&type=template&id=5fa49698&scoped=true&"
import script from "./DbModal.vue?vue&type=script&lang=ts&"
export * from "./DbModal.vue?vue&type=script&lang=ts&"
import style0 from "./DbModal.vue?vue&type=style&index=0&id=5fa49698&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa49698",
  null
  
)

export default component.exports